import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";

const WhySummitMattersSection = (props) => {
  const points = [
    {
      title: "Unlock Financial Clarity",
      description:
        "Understand exactly where your money comes from — and where it leaks.",
      icon: "flaticon-balance",
      bgColor: "linear-gradient(135deg, #6A82FB 0%, #4A63D8 100%)",
    },
    {
      title: "Create Predictable Income",
      description:
        "Build systems to ensure steady, reliable cash inflow every month.",
      icon: "flaticon-diary",
      bgColor: "linear-gradient(135deg, #F7971E 0%, #FFD200 100%)",
    },
    {
      title: "Scale Without Stress",
      description: "Learn how to expand without running dry on funds.",
      icon: "flaticon-support",
      bgColor: "linear-gradient(135deg, #00C9FF 0%, #92FE9D 100%)",
    },
    {
      title: "Attract Smart Investments",
      description:
        "Present your numbers with confidence and win investor trust.",
      icon: "flaticon-auction",
      bgColor: "linear-gradient(135deg, #FF6A88 0%, #FF99AC 100%)",
    },
    {
      title: "Learn from Real Entrepreneurs",
      description:
        "Hear proven case studies of businesses that turned chaos into cash.",
      icon: "flaticon-user",
      bgColor: "linear-gradient(135deg, #7F00FF 0%, #E100FF 100%)",
    },
  ];

  return (
    <section
      className={"why-summit-matters-section section-padding " + (props.hclass || "")}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <SectionTitle
              title="Why Cash Flow Summit Matters"
              subtitle=""
              paragarap="When your cash flow works, everything in your business works."
              titleStyle={{ color: "#252686" }}
              paragraphStyle={{ color: "#525252" }}
            />
          </div>
        </div>

        <div
          className="row justify-content-center"
          style={{ maxWidth: 1150, margin: "0 auto" }}
        >
          {points.map((item, idx) => (
            <div
              className="col col-xl-4 col-lg-6 col-md-6 col-12"
              key={idx}
              style={{ marginBottom: 24, display: "flex" }}
            >
              <div
                className="services-card"
                style={{
                  padding: 24,
                  borderRadius: 12,
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 14,
                  height: "100%",
                  width: "100%",
                  boxShadow: "0px 2px 8px rgba(34,31,60,0.1)",
                  transition: "transform 0.25s ease, box-shadow 0.25s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 24px rgba(34,31,60,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0px 2px 8px rgba(34,31,60,0.1)";
                }}
              >
                <div
                  style={{
                    width: 58,
                    height: 58,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: item.bgColor,
                    color: "#fff",
                    flex: "0 0 58px",
                    boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
                  }}
                >
                  <i className={item.icon} style={{ fontSize: 22 }} />
                </div>
                <div>
                  <h3
                    style={{
                      fontSize: 20,
                      fontWeight: 800,
                      color: "#242424",
                      marginBottom: 8,
                    }}
                  >
                    {item.title}
                  </h3>
                  <p style={{ margin: 0, color: "#555", lineHeight: 1.6 }}>
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySummitMattersSection;
